<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <va-button flat ouline color="red" >1. 请务必按照示例的格式上传，每个excel中只能存在一个sheet，不要重复上传同一个文件</va-button>
          <va-button flat ouline color="red" >2. 上传成功后，下方列表可以查看从该文件中读取到的内容，如果有错误的，可以直接删除</va-button>
          <va-button flat ouline color="red" >3. 审核完毕后，点击一键发布，期间不要刷新或者切换其他页面</va-button>
          <va-button flat ouline color="red" >4. 如果步骤3操作失误，那么直接点击返回岗位列表，可在草稿中查看刚上传的岗位</va-button>
          <div class='flex md12 sm6 xs12'>
            <a href="https://static.libaspace.com/image/20231002/b655bb2baba04d0b9d9bf8582f89d0ba.xlsx" target="_Blank">
              <va-button class="ma-0" color="primary" slot="trigger">
                查看示例<!--{{insertData.fileName}}-->
              </va-button>
            </a>
          </div>
          <!--          https://static.libaspace.com/image/20221218/31558764253e487da08d6408bdef97df.xlsx-->
          <div class="flex md12 sm6 xs12">
            <va-card title='封面展示图'>
              <va-file-upload
                type='single'
                dropzone="dropzone"
                v-model='insertData.excelArr'
                @input="uploadExcel"
              />
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='errorMsg'
              label='处理结果'
              disabled
            />
          </div>
        </div>
        <div class="row justify--center">
          <div class="flex mb-2 justify--center">
            <va-button color="gray" slot="trigger" @click="$router.push({ name: 'referral'})">
              返回岗位列表
            </va-button>
          </div>
        </div>
      </va-card>
    </div>
    <div class="flex xs10 offset--xs1">
      <va-card title="临时列表(刷新页面后就会清空)">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm12">
            <div class="d-flex justify--end">
              <va-button color="info" small @click="publishModal=true" :disabled="referrals.length === 0">一键发布</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="referrals"
          :loading="loading"
          api-mode
        >
          <template slot="actions" slot-scope="props">
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal=true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除岗位"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
        <va-modal
          v-model="publishModal"
          title="一键发布"
          okText="提交"
          position="center"
          message="请确认已经全部审核完毕？"
          @ok="confirmPublish"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '@/api/upload'
import referralApi from '@/api/referral'

export default {
  data () {
    return {
      insertData: {
        excelArr: [],
      },
      message: ['Required field'],
      showId: false,
      title: '上传岗位Excel',
      errorMsg: '',
      referrals: [],
      loading: false,
      deleteId: null,
      deleteModal: false,
      publishModal: false,
    }
  },
  created () {
  },
  computed: {
    fields () {
      return [
        {
          name: 'organizationName',
          title: '企业名称',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'position',
          title: '职位',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'location',
          title: '工作地点',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'courseTags',
          title: '标签',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'link',
          title: '链接',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  methods: {
    clickCancel () {
    },
    uploadExcel () {
      if (this.insertData.excelArr.length === 0) return
      this.errorMsg = '请稍等........'
      const formData = new FormData()
      formData.append('file', this.insertData.excelArr[this.insertData.excelArr.length - 1])
      uploadApi.uploadCareerExcel(formData).then(response => {
        console.log(response)
        this.errorMsg = '上传成功'
        this.referrals = response.referralDtos
        this.showToast('上传成功', {
          duration: 1000,
          icon: 'fa-success',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 10000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        this.errorMsg = error.msg
      })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      referralApi.deleteReferral(this.deleteId).then(response => {
        if (response.success === true) {
          const tmp = []
          this.referrals.forEach(x => {
            if (x.id !== this.deleteId) {
              tmp.push(x)
            }
          })
          this.referrals = tmp
          this.deleteId = null
          this.showToast('删除成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
        }
      }).catch(error =>
        this.showToast(error.msg, {
          duration: 10000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        }))
    },
    confirmPublish () {
      if (this.referrals.length === 0) return
      const ids = []
      this.referrals.forEach(x => {
        ids.push(x.id)
      })
      const params = {
        ids: ids,
      }
      referralApi.publishAll(params).then(response => {
        if (response.success === true) {
          this.referrals = []
          this.showToast('发布成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
        }
      }).catch(error =>
        this.showToast(error.msg, {
          duration: 10000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        }))
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
